export type ResourceDataRow = {
  label: string;
  series: string;
  value: number;
};

export enum Periods {
  curr_month = 'curr_month',
  prev_month = 'prev_month',
  quarter = 'quarter',
  year_to_date = 'year_to_date',
  custom = 'custom',
}

export enum Quarters {
  q1 = 'q1',
  q2 = 'q2',
  q3 = 'q3',
  q4 = 'q4',
  'undefined' = '',
}

export type ResourcesDataFilterQuarter = {
  period: Periods.quarter;
  quarter: Quarters;
};

export type ResourcesDataFilterCustom = {
  period: Periods.custom;
  range: [Date, Date] | undefined;
};

export type ResourcesDataFilterDefined = {
  period: Exclude<Periods, Periods.quarter | Periods.custom>;
};

export type ResourcesDataFilter = ResourcesDataFilterQuarter | ResourcesDataFilterCustom | ResourcesDataFilterDefined;

export type ComponentResourcesFilterObject = {
  category?: string;
  date?: ResourcesDataFilter;
};
